<script setup>
import ActionButton from '@/components/shared/buttons/ActionButton.vue'

//Emits and props
defineEmits([
  'click',
])
</script>

<template>
  <ActionButton
    v-bind="$attrs"
    type="text"
    icon="download"
    aria-label="Download image"
    test-id="imageDownloadButton"
    @click="$emit('click', $event)"
  />
</template>
